import Vue from "vue";
import App from "./App.vue";
import "./theme/index.less";
import Antd from "ant-design-vue";
import { message } from "ant-design-vue";
// import '@/mock'
import store from "./store";
import "animate.css/source/animate.css";
import Plugins from "@/plugins";
import bootstrap from "@/bootstrap";
import "moment/locale/zh-cn";
import $axios from "axios";
import * as $httpAu from "./utils/auth";
import * as $http from "./utils/http";
import { loadRoutes } from "@/utils/routerUtil";
import { getFileType } from "@/utils/util";

import { initRouter, loginIgnore } from "./router";

import ElementUI from "element-ui";

if (!["uat", "preview", "test"].includes(process.env.VUE_APP_ENVIRONMENT)) {
  import("element-ui/lib/theme-chalk/index.css");
}

//  引入Echarts
import * as echarts from "echarts";
import "./config/components";

Vue.prototype.$echarts = echarts;

Vue.use(ElementUI);

Vue.use(Antd);
Vue.config.productionTip = false;
Vue.use(Plugins);
Vue.prototype.$message = message;
Vue.prototype.$httpAu = $httpAu; //获取token
Vue.prototype.$http = $http;
Vue.prototype.$axios = $axios;
Vue.prototype.$bus = new Vue();
const router = initRouter;
bootstrap({ router, store, message: Vue.prototype.$message });

let timer = null;
router.beforeEach((to, from, next) => {
  let token = store.getters["account/token"]();
  const routesConfig = store.getters["account/routesConfig"];

  if (to.path === "/login") {
    next();
    return;
  }

  to.meta.fullPath = to.fullPath;

  const refresh_token_time = localStorage.getItem("refresh_token_time");
  if (Date.now() > +refresh_token_time) {
    message.destroy();
    message.warn("登录过期，请重新登录");
    $httpAu.logout();
    next({ path: "/login", query: { redirect: to.fullPath } });
    return;
  }
  if (token) {
    if (routesConfig && routesConfig.length) {
      if (to.path === "/login") {
        next("/index/Workplace");
        return;
      }
      next();
    } else {
      //加载路由
      const redirect = decodeURIComponent(from.query.redirect || to.fullPath);
      $http.getUserModule({
        adminId: store.getters["account/user"].id,
        applicationId: 1,
      }).then(res => {
        const data = res.data;
        if (!data.menu || !data.menu.length || !data.auth.length) {
          message.error("用户无权限，请联系管理员");
          next("/login");
          return;
        }
        const PermissionsArr = data.auth.filter((v) => {
          return v.operation && v.operation.some((s) => s.toLowerCase().indexOf("view") >= 0);
        });
        const RouterArray = [
          {
            children: data.menu,
            router: "root",
          },
        ];
        store.commit("account/setPermissions", PermissionsArr);
        loadRoutes(RouterArray);
        next(redirect);
      });
    }

    const skipPathName = ["404", "工作台", "分析页"];
    const parent = to.matched[to.matched.length - 2];
    if ((!to.meta.invisible || (!parent.meta.invisible && to.path.includes(parent.redirect))) && !skipPathName.includes(to.meta.title)) {
      const recentVisit = store.state.account.recentVisit;
      if (!recentVisit.some((item) => item.path === to.path)) {
        const recent = {};
        const menuData = store.getters["setting/menuData"];
        recent.adminId = store.getters["account/user"].id;
        recent.path = to.path;
        recent.name = to.meta.title;
        const fullPaths = String(to.fullPath).split("/").filter(Boolean);
        for (let i = 0; i < menuData.length; i++) {
          if (menuData[i].path == fullPaths[0]) {
            recent.icon = menuData[i].meta.icon;
            break;
          }
        }
        clearTimeout(timer);
        timer = setTimeout(() => {
          store.commit("account/set_recentVisit", recent);
        }, 500);
      }
    }
  } else {
    if (loginIgnore.includes(to)) {
      //判断是否需要拦截
      next();
    } else {
      next({ path: "/login", query: { redirect: to.fullPath } });
    }
  }
});

Vue.mixin({
  data() {
    return {
      _templatePath: process.env.VUE_APP_TEMPLATE_URL,
      // 学段
      _period: ["学前", "小学低段", "小学中段", "小学高段", "小学", "初中", "高中", "中学", "全学段", "乘风之旅", "摘星之旅", "探月之旅"],
      // 题目类型 （数组下标）
      _questionType: ["", "单选题", "多选题", "量表题", "矩阵单选", "矩阵多选", "矩阵量表", "填空题", "文件上传", "问答题"],
      // 内容类型 （数组下标）
      _contentType: ["", "测评游戏", "训练游戏", "题目壳", "课程视频", "亲子游戏", "问卷"],
      _courseType: {
        1: "测评",
        2: "训练",
        3: "活动",
      },
    };
  },
});

/**
 * 2024-01-11 cdn域名调整
 * storage.iquizoo.com 不走cdn缓存的域名
 * cdn.iquizoo.com cdn缓存的域名
 * vue全局过滤器
 * 如果资源链接上面带有域名，就直接使用该链接，反之则需要拼接域名地址
 * @param value string url地址
 * @param storage boolean 是否需要cdn缓存，默认false
 */
const filterUrl = function(value, storage = false) {
  if (!value) return "";
  if (value.slice(0, 4) === "http" || ["data:", "blob:"].includes(value.slice(0, 5))) return value;
  if (value[0] !== "/") {
    value = "/" + value;
  }
  if (storage === "template") return "https://storage.iquizoo.com/static" + value;
  if (process.env.VUE_APP_ENVIRONMENT !== "preview") return "https://static.iquizoo.com" + value;
  if (storage) return "https://cdn.iquizoo.com" + value;
  return "https://storage.iquizoo.com" + value;
};
Vue.filter("filterUrl", filterUrl);

function replaceEmpty(e) {
  e.target.value = String(e.target.value).trim();
}

Vue.directive("trim", {
  bind(el, binding, vnode) {
    el.addEventListener("input", replaceEmpty);
  },
  unbind(el) {
    el.removeEventListener("input", replaceEmpty);
  },
});
Vue.prototype.$filterUrl = filterUrl;
Vue.prototype.$getFileType = getFileType;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
